import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import {
  COLOR_BLACK,
  COLOR_WHITE,
  COLOR_RED,
  COLOR_BLUE,
  COLOR_GREEN,
} from '../../assets/styles/colors';

export const HeadingFourSC = styled.h4`
  color: ${COLOR_BLACK};
  font-size: 23px;
  line-height: 1.39;
  font-weight: bold;
  margin-bottom: 0;
  &.white {
    color: ${COLOR_WHITE};
  }
  &.red {
    color: ${COLOR_RED};
  }
  &.green {
    color: ${COLOR_GREEN};
  }
  &.blue {
    color: ${COLOR_BLUE};
  }
  &.chart-grey {
    color: #83828f;
  }
  &.bigger {
    font-size: 30px;
    line-height: 32px;
  }
`;

const HeadingFour = (props) => {
  const { children, className } = props;
  const customClass = classNames({ [className]: className !== '' });

  return <HeadingFourSC className={customClass}>{children}</HeadingFourSC>;
};

HeadingFour.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

HeadingFour.defaultProps = {
  className: '',
};

export default HeadingFour;
